import * as React from 'react'
import {ResponsiveValue} from '../..'
import IconBase from './IconBase'

const Arrow: React.FC<{
  width?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
  direction?: 'left' | 'right' | 'top' | 'bottom'
}> = ({width = 15, height = 12, direction, ...props}) => {
  let directionValue = ''

  switch (direction) {
    case 'left':
      directionValue = 'rotate(180deg)'
      break
    case 'top':
      directionValue = 'rotate(270deg)'
      break
    case 'bottom':
      directionValue = 'rotate(90deg)'
      break
    default:
      directionValue = 'rotate(0deg)'
  }

  return (
    <IconBase $styles={{width, height, transform: directionValue}} viewBox="0 0 15 12" {...props}>
      <rect width={13} height={2} rx={1} transform="matrix(-1 0 0 1 13 5)" fill="#fff" />
      <path d="M8 1l5 5-5 5" stroke="#fff" strokeWidth={2} strokeLinecap="round" />
    </IconBase>
  )
}

export default Arrow
